






































































import { Component, Mixins, Emit } from "vue-property-decorator";
import { Rectangle, Point } from "../../domain/drawing";
import { RectangleDragHandlesMixin } from "./mixins";
import RectangleResizeDragHandle from "./RectangleResizeDragHandle.vue";
import MoveDragHandleArea from "./MoveDragHandleArea.vue";

@Component({
  components: {
    RectangleResizeDragHandle,
    MoveDragHandleArea,
  },
})
export default class RectangleDragHandles extends Mixins(RectangleDragHandlesMixin) {
  get rectangle(): Rectangle {
    return new Rectangle(
      new Point(0, 0),
      this.size
    );
  }

  @Emit()
  click(event: PointerEvent): void {}

  @Emit()
  dblclick(event: PointerEvent): void {}

  @Emit()
  clickPrevented(event: PointerEvent): void {}

  @Emit()
  dblclickPrevented(event: PointerEvent): void {}
}
